import {ProductsQueryState} from '../reducers/dashboard';

const TYPES = {
    GET_PRODUCTS: 'GET_PRODUCTS',
    GET_PRODUCTS_COMPLETE: 'GET_PRODUCTS_COMPLETE',
    GET_PRODUCTS_FAILED: 'GET_PRODUCTS_FAILED',

    GET_EARNED_PRODUCTS: 'GET_EARNED_PRODUCTS',
    GET_EARNED_PRODUCTS_COMPLETE: 'GET_EARNED_PRODUCTS_COMPLETE',
    GET_EARNED_PRODUCTS_FAILED: 'GET_EARNED_PRODUCTS_FAILED',

    GET_EARNINGS_DATA: 'GET_EARNINGS_DATA',
    GET_EARNINGS_DATA_COMPLETE: 'GET_EARNINGS_DATA_COMPLETE',
    GET_EARNINGS_DATA_FAILED: 'GET_EARNINGS_DATA_FAILED',

    RESET_PRODUCTS: 'RESET_PRODUCTS',
    UPDATE_PRODUCTS_QUERY_STATE: 'UPDATE_PRODUCTS_QUERY_STATE'
};

export default {
    TYPES,

    getProducts: (payload?) => ({
        type: TYPES.GET_PRODUCTS,
        payload
    }),

    getProductsSuccess: (payload?) => ({
        type: TYPES.GET_PRODUCTS_COMPLETE,
        payload
    }),

    getProductsFailed: (error?) => ({
        type: TYPES.GET_PRODUCTS_FAILED,
        payload: {error}
    }),

    getEarnedProducts: (payload?) => ({
        type: TYPES.GET_EARNED_PRODUCTS,
        payload
    }),

    getEarnedProductsSuccess: (payload?) => ({
        type: TYPES.GET_EARNED_PRODUCTS_COMPLETE,
        payload
    }),

    getEarnedProductsFailed: (error?) => ({
        type: TYPES.GET_EARNED_PRODUCTS_FAILED,
        payload: {error}
    }),

    getEarningsData: (payload?) => ({
        type: TYPES.GET_EARNINGS_DATA,
        payload
    }),

    getEarningsDataSuccess: (payload?) => ({
        type: TYPES.GET_EARNINGS_DATA_COMPLETE,
        payload
    }),

    getEarningsDataFailed: (error?) => ({
        type: TYPES.GET_EARNINGS_DATA_FAILED,
        payload: {error}
    }),

    resetProducts: () => ({
        type: TYPES.RESET_PRODUCTS
    }),

    updateProductQueryState: (payload?: Partial<ProductsQueryState>) => ({
        type: TYPES.UPDATE_PRODUCTS_QUERY_STATE,
        payload
    })
};
